import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";

import { crudeDatabase } from "../data/crudeDatabase";
import { generateBlend } from "../engine/blendEngine";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";






function StripperLaboratory({ onClose }) {

    const [currentPage, setCurrentPage] = useState(0);


    const report =
        JSON.parse(
            localStorage.getItem("ProductStripperReport") || "{}"
        );


    /* ==========================================
   DIESEL STRIPPER
========================================== */

    const {
        dieselFeedFlow,
        dieselFeedTemperature,
        dieselFeedPressure,

        steamFlow,
        steamTemperature,
        steamPressure,

        dieselBottomFlow,
        dieselBottomTemperature,
        dieselBottomPressure,

        dieselOverheadFlow,
        dieselOverheadTemperature,
        dieselOverheadPressure,

        dieselRecovery,
        dieselLoss,

        steamRatio,
        steamStrippingFactor,
        temperatureFactor,
        pressureFactor,

        dieselComposition,
        dieselGasComposition,

        /* ==========================================
           KEROSENE STRIPPER
        ========================================== */

        keroseneFeedFlow,
        keroseneFeedTemperature,
        keroseneFeedPressure,

        reboilerInletFlow,
        reboilerOutletFlow,

        reboilerInletTemperature,
        reboilerOutletTemperature,

        keroseneBottomFlow,
        keroseneBottomTemperature,
        keroseneBottomPressure,

        keroseneOverheadFlow,
        keroseneOverheadTemperature,
        keroseneOverheadPressure,

        keroseneRecovery,
        keroseneLoss,

        keroseneComposition,
        keroseneGasComposition,

        /* ==========================================
           REBOILER
        ========================================== */

        reboilerDuty,
        heatTransferred,
        deltaT,

        /* ==========================================
           PUMPS
        ========================================== */

        dieselPumpFlow,
        dieselPumpTemperature,
        dieselPumpPressure,

        kerosenePumpFlow,
        kerosenePumpTemperature,
        kerosenePumpPressure,

        /* ==========================================
           OVERALL PERFORMANCE
        ========================================== */

        overallRecovery,
        energyEfficiency,
        overallPerformance,
        heatTransferEfficiency,
        steamConsumption,
        strippingSeverity,

    } = report;



    const reportInfo = {

        receiptNumber:
            `STR-${Date.now()}`,

        generatedOn:
            new Date().toLocaleString()

    };




    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);


    console.log(
        "STABILIZER REPORT DATA",
        report
    );


    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">

                {currentPage === 0 && (

                    /* ==========================================
                       PAGE 0
                       COVER PAGE
                    ========================================== */

                    <div className="receipt-page">

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 30
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "#003366",
                                    letterSpacing: 1
                                }}
                            >
                                NK TECH NIGERIA LIMITED
                            </div>

                            <div
                                style={{
                                    fontSize: 14,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                NK REFINERY DIGITAL TWIN SYSTEM
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                PROCESS SIMULATION • DIGITAL LABORATORY • OPERATIONS MONITORING
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                textAlign: "center",
                                margin: "30px 0"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    fontSize: 34,
                                    color: "#0B4F9C",
                                    letterSpacing: 2
                                }}
                            >
                                PRODUCT STRIPPER
                            </h1>

                            <h2
                                style={{
                                    marginTop: 10,
                                    marginBottom: 8,
                                    color: "#444",
                                    fontWeight: 600
                                }}
                            >
                                PROCESS LABORATORY REPORT
                            </h2>

                            <div
                                style={{
                                    fontSize: 17,
                                    fontWeight: "bold",
                                    color: "#666"
                                }}
                            >
                                DIESEL / KEROSENE STRIPPING UNIT
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    fontSize: 13,
                                    color: "#888"
                                }}
                            >
                                Equipment Tag : T-2401 / T-2402
                            </div>

                        </div>

                        <table
                            className="receipt-table"
                            style={{
                                marginTop: "50px"
                            }}
                        >

                            <tbody>

                                <tr>

                                    <td>Report Type</td>

                                    <td>Product Stripper Performance Report</td>

                                </tr>

                                <tr>

                                    <td>Plant</td>

                                    <td>NK Refinery Digital Twin</td>

                                </tr>

                                <tr>

                                    <td>Unit</td>

                                    <td>Diesel & Kerosene Product Stripper</td>

                                </tr>

                                <tr>

                                    <td>Total Feed Flow</td>

                                    <td>

                                        {(dieselFeedFlow + keroseneFeedFlow).toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Total Steam Flow</td>

                                    <td>

                                        {steamFlow.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Recovery</td>

                                    <td>

                                        {overallRecovery.toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Performance</td>

                                    <td>

                                        {overallPerformance.toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Report Generated</td>

                                    <td>

                                        {reportInfo.generatedOn}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <div
                            style={{
                                marginTop: "50px",
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center"
                            }}
                        >

                            <div>

                                <QRCode

                                    value={JSON.stringify({

                                        System:
                                            "NK REFINERY DIGITAL TWIN SYSTEM",

                                        Report:
                                            "PRODUCT STRIPPER PERFORMANCE REPORT",

                                        Unit:
                                            "PRODUCT STRIPPER",

                                        ReportID:
                                            reportInfo.receiptNumber,

                                        Date:
                                            reportInfo.generatedOn

                                    })}

                                    size={120}

                                />

                            </div>

                            <div>

                                <Barcode

                                    value={reportInfo.receiptNumber}

                                    width={1.5}

                                    height={60}

                                    fontSize={14}

                                />

                            </div>

                        </div>

                        <div
                            style={{
                                marginTop: "40px",
                                textAlign: "center",
                                fontStyle: "italic",
                                color: "#555"
                            }}
                        >

                            This report was generated automatically from live process
                            simulation data within the NK Refinery Digital Twin System.
                            The values presented represent simulated operating conditions
                            intended for training, process monitoring, educational,
                            demonstration and performance evaluation purposes.

                        </div>

                    </div>

                )}


                {currentPage === 1 && (

                    /* ==========================================
                       PAGE 1
                       DIESEL STRIPPER FEED ANALYSIS
                    ========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            1. DIESEL STRIPPER FEED ANALYSIS

                        </h2>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Diesel Feed Flow</td>

                                    <td>{dieselFeedFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Feed Temperature</td>

                                    <td>{dieselFeedTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Feed Pressure</td>

                                    <td>{dieselFeedPressure.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Steam Flow</td>

                                    <td>{steamFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Steam Temperature</td>

                                    <td>{steamTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Steam Pressure</td>

                                    <td>{steamPressure.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Steam/Oil Ratio</td>

                                    <td>{steamRatio.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Steam Stripping Factor</td>

                                    <td>{steamStrippingFactor.toFixed(3)}</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Operating Factors

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Temperature Factor</td>

                                    <td>{temperatureFactor.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Pressure Factor</td>

                                    <td>{pressureFactor.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Stripping Severity</td>

                                    <td>{strippingSeverity.toFixed(3)}</td>

                                </tr>

                                <tr>

                                    <td>Diesel Recovery</td>

                                    <td>{dieselRecovery.toFixed(2)} %</td>

                                </tr>

                                <tr>

                                    <td>Diesel Loss to Overhead</td>

                                    <td>{dieselLoss.toFixed(3)} m³/hr</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Diesel Feed Interpretation

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Feed Condition</td>

                                    <td>

                                        {

                                            dieselFeedTemperature >= 220

                                                ? "Excellent Feed Temperature"

                                                : dieselFeedTemperature >= 190

                                                    ? "Good Feed Temperature"

                                                    : "Low Feed Temperature"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Distribution</td>

                                    <td>

                                        {

                                            steamRatio >= 0.03

                                                ? "Adequate"

                                                : "Low Steam Supply"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stripping Condition</td>

                                    <td>

                                        {

                                            strippingSeverity >= 0.80

                                                ? "Excellent"

                                                : strippingSeverity >= 0.60

                                                    ? "Good"

                                                    : strippingSeverity >= 0.40

                                                        ? "Moderate"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Recovery Status</td>

                                    <td>

                                        {

                                            dieselRecovery >= 98

                                                ? "Excellent Recovery"

                                                : dieselRecovery >= 95

                                                    ? "Good Recovery"

                                                    : "Requires Optimization"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}


                {currentPage === 2 && (

                    /* ==========================================
                       PAGE 2
                       DIESEL STRIPPER PRODUCT ANALYSIS
                    ========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            2. DIESEL STRIPPER PRODUCT ANALYSIS

                        </h2>

                        <h3>

                            Bottom Product

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Bottom Product Flow</td>

                                    <td>{dieselBottomFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Bottom Temperature</td>

                                    <td>{dieselBottomTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Bottom Pressure</td>

                                    <td>{dieselBottomPressure.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Diesel Recovery</td>

                                    <td>{dieselRecovery.toFixed(2)} %</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Overhead Vapor

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Overhead Flow</td>

                                    <td>{dieselOverheadFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Overhead Temperature</td>

                                    <td>{dieselOverheadTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Overhead Pressure</td>

                                    <td>{dieselOverheadPressure.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Diesel Loss</td>

                                    <td>{dieselLoss.toFixed(3)} m³/hr</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Bottom Product Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Volume %</th>

                                </tr>

                            </thead>

                            <tbody>

                                {

                                    Object.entries(dieselComposition || {}).map(

                                        ([component, value]) => (

                                            <tr key={component}>

                                                <td>{component}</td>

                                                <td>{(value * 100).toFixed(3)} %</td>

                                            </tr>

                                        )

                                    )

                                }

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Overhead Gas Composition

                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Component</th>

                                    <th>Flow (m³/hr)</th>

                                </tr>

                            </thead>

                            <tbody>

                                {

                                    Object.entries(dieselGasComposition || {}).map(

                                        ([component, value]) => (

                                            <tr key={component}>

                                                <td>{component}</td>

                                                <td>{Number(value).toFixed(3)}</td>

                                            </tr>

                                        )

                                    )

                                }

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Product Performance Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Bottom Product Quality</td>

                                    <td>

                                        {

                                            dieselRecovery >= 98

                                                ? "Excellent"

                                                : dieselRecovery >= 95

                                                    ? "Good"

                                                    : dieselRecovery >= 90

                                                        ? "Acceptable"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overhead Hydrocarbon Loss</td>

                                    <td>

                                        {

                                            dieselLoss <= 0.05

                                                ? "Very Low"

                                                : dieselLoss <= 0.15

                                                    ? "Acceptable"

                                                    : "High"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Diesel Stripping</td>

                                    <td>

                                        {

                                            strippingSeverity >= 0.80

                                                ? "Excellent"

                                                : strippingSeverity >= 0.60

                                                    ? "Good"

                                                    : strippingSeverity >= 0.40

                                                        ? "Fair"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}




                {currentPage === 3 && (

                    /* ==========================================
                       PAGE 3
                       KEROSENE STRIPPER FEED ANALYSIS
                    ========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            3. KEROSENE STRIPPER FEED ANALYSIS

                        </h2>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Kerosene Feed Flow</td>

                                    <td>{keroseneFeedFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Feed Temperature</td>

                                    <td>{keroseneFeedTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Feed Pressure</td>

                                    <td>{keroseneFeedPressure.toFixed(3)} barg</td>

                                </tr>

                                <tr>

                                    <td>Reboiler Inlet Flow</td>

                                    <td>{reboilerInletFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Reboiler Outlet Flow</td>

                                    <td>{reboilerOutletFlow.toFixed(3)} m³/hr</td>

                                </tr>

                                <tr>

                                    <td>Reboiler Inlet Temperature</td>

                                    <td>{reboilerInletTemperature.toFixed(2)} °C</td>

                                </tr>

                                <tr>

                                    <td>Reboiler Outlet Temperature</td>

                                    <td>{reboilerOutletTemperature.toFixed(2)} °C</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Kerosene Feed Evaluation

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Feed Condition</td>

                                    <td>

                                        {

                                            keroseneFeedTemperature >= 210

                                                ? "Excellent"

                                                : keroseneFeedTemperature >= 180

                                                    ? "Good"

                                                    : "Low Feed Temperature"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Temperature Rise (ΔT)</td>

                                    <td>

                                        {deltaT.toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Heat Transfer Efficiency</td>

                                    <td>

                                        {heatTransferEfficiency.toFixed(2)} %

                                    </td>

                                </tr>

                                <tr>

                                    <td>Energy Efficiency</td>

                                    <td>

                                        {energyEfficiency.toFixed(2)} %

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <h3>

                            Feed Assessment

                        </h3>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Heating Performance</td>

                                    <td>

                                        {

                                            heatTransferEfficiency >= 90

                                                ? "Excellent"

                                                : heatTransferEfficiency >= 80

                                                    ? "Good"

                                                    : heatTransferEfficiency >= 70

                                                        ? "Fair"

                                                        : "Poor"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Reboiler Condition</td>

                                    <td>

                                        {

                                            deltaT >= 20

                                                ? "Adequate Heating"

                                                : "Insufficient Heating"

                                        }

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Feed Readiness</td>

                                    <td>

                                        {

                                            energyEfficiency >= 85

                                                ? "Excellent"

                                                : energyEfficiency >= 70

                                                    ? "Good"

                                                    : "Needs Optimization"

                                        }

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}



                {currentPage === 4 && (

                    /* ==========================================
                       PAGE 4
                       KEROSENE STRIPPER PRODUCT ANALYSIS
                    ========================================== */

                    <div className="receipt-page">

                        <h2 className="receipt-section-title">

                            4. KEROSENE STRIPPER PRODUCT ANALYSIS

                        </h2>


                        <h3>

                            Kerosene Bottom Product

                        </h3>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Bottom Product Flow</td>

                                    <td>

                                        {keroseneBottomFlow.toFixed(3)} m³/hr

                                    </td>

                                </tr>


                                <tr>

                                    <td>Bottom Temperature</td>

                                    <td>

                                        {keroseneBottomTemperature.toFixed(2)} °C

                                    </td>

                                </tr>


                                <tr>

                                    <td>Bottom Pressure</td>

                                    <td>

                                        {keroseneBottomPressure.toFixed(3)} barg

                                    </td>

                                </tr>


                                <tr>

                                    <td>Kerosene Recovery</td>

                                    <td>

                                        {keroseneRecovery.toFixed(2)} %

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Kerosene Overhead Vapor

                        </h3>


                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Overhead Flow</td>

                                    <td>

                                        {keroseneOverheadFlow.toFixed(3)} m³/hr

                                    </td>

                                </tr>


                                <tr>

                                    <td>Overhead Temperature</td>

                                    <td>

                                        {keroseneOverheadTemperature.toFixed(2)} °C

                                    </td>

                                </tr>


                                <tr>

                                    <td>Overhead Pressure</td>

                                    <td>

                                        {keroseneOverheadPressure.toFixed(3)} barg

                                    </td>

                                </tr>


                                <tr>

                                    <td>Kerosene Loss</td>

                                    <td>

                                        {keroseneLoss.toFixed(3)} m³/hr

                                    </td>

                                </tr>

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Kerosene Bottom Composition

                        </h3>


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Composition
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {

                                    Object.entries(

                                        keroseneComposition || {}

                                    ).map(

                                        ([component, value]) => (

                                            <tr key={component}>

                                                <td>

                                                    {component}

                                                </td>


                                                <td>

                                                    {

                                                        (value * 100)

                                                            .toFixed(3)

                                                    } %

                                                </td>

                                            </tr>

                                        )

                                    )

                                }

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Kerosene Overhead Gas Composition

                        </h3>


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>

                                    <th>
                                        Flow
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {

                                    Object.entries(

                                        keroseneGasComposition || {}

                                    ).map(

                                        ([component, value]) => (

                                            <tr key={component}>

                                                <td>

                                                    {component}

                                                </td>


                                                <td>

                                                    {

                                                        Number(value)

                                                            .toFixed(3)

                                                    } m³/hr

                                                </td>

                                            </tr>

                                        )

                                    )

                                }

                            </tbody>

                        </table>


                        <br />


                        <h3>

                            Kerosene Stripping Performance

                        </h3>


                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        Recovery Performance
                                    </td>


                                    <td>

                                        {

                                            keroseneRecovery >= 98

                                                ?

                                                "Excellent Recovery"

                                                :

                                                keroseneRecovery >= 95

                                                    ?

                                                    "Good Recovery"

                                                    :

                                                    keroseneRecovery >= 90

                                                        ?

                                                        "Acceptable"

                                                        :

                                                        "Requires Optimization"

                                        }

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Hydrocarbon Loss
                                    </td>


                                    <td>

                                        {

                                            keroseneLoss <= 0.05

                                                ?

                                                "Very Low Loss"

                                                :

                                                keroseneLoss <= 0.15

                                                    ?

                                                    "Acceptable Loss"

                                                    :

                                                    "High Loss"

                                        }

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Product Quality Status
                                    </td>


                                    <td>

                                        {

                                            keroseneRecovery >= 97

                                                ?

                                                "On Specification"

                                                :

                                                "Review Operating Conditions"

                                        }

                                    </td>

                                </tr>


                            </tbody>

                        </table>


                    </div>

                )}



                {currentPage === 5 && (

                    /* ==========================================
                       PAGE 5
                       REBOILER PERFORMANCE ANALYSIS
                    ========================================== */

                    <div className="receipt-page">


                        <h2 className="receipt-section-title">

                            5. REBOILER PERFORMANCE ANALYSIS

                        </h2>



                        <h3>

                            Reboiler Operating Parameters

                        </h3>


                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        Reboiler Duty
                                    </td>

                                    <td>

                                        {reboilerDuty.toFixed(2)} kW

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Heat Transferred
                                    </td>

                                    <td>

                                        {heatTransferred.toFixed(2)} kW

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Heat Transfer Efficiency
                                    </td>

                                    <td>

                                        {heatTransferEfficiency.toFixed(2)} %

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Temperature Difference (ΔT)
                                    </td>

                                    <td>

                                        {deltaT.toFixed(2)} °C

                                    </td>

                                </tr>


                            </tbody>


                        </table>



                        <br />



                        <h3>

                            Reboiler Flow Performance

                        </h3>



                        <table className="receipt-table">


                            <tbody>


                                <tr>

                                    <td>
                                        Reboiler Inlet Flow
                                    </td>

                                    <td>

                                        {reboilerInletFlow.toFixed(3)} m³/hr

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Reboiler Outlet Flow
                                    </td>

                                    <td>

                                        {reboilerOutletFlow.toFixed(3)} m³/hr

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Flow Difference
                                    </td>

                                    <td>

                                        {

                                            (

                                                reboilerOutletFlow -

                                                reboilerInletFlow

                                            )

                                                .toFixed(3)

                                        } m³/hr


                                    </td>

                                </tr>


                            </tbody>


                        </table>



                        <br />



                        <h3>

                            Temperature Profile

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Location
                                    </th>


                                    <th>
                                        Temperature
                                    </th>


                                </tr>


                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Reboiler Inlet
                                    </td>


                                    <td>

                                        {reboilerInletTemperature.toFixed(2)} °C

                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Reboiler Outlet
                                    </td>


                                    <td>

                                        {reboilerOutletTemperature.toFixed(2)} °C

                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Temperature Increase
                                    </td>


                                    <td>

                                        {

                                            (

                                                reboilerOutletTemperature -

                                                reboilerInletTemperature

                                            )

                                                .toFixed(2)

                                        } °C


                                    </td>


                                </tr>


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Reboiler Efficiency Assessment

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Heat Transfer Condition
                                    </td>


                                    <td>

                                        {

                                            heatTransferEfficiency >= 90

                                                ?

                                                "Excellent Heat Transfer"

                                                :

                                                heatTransferEfficiency >= 80

                                                    ?

                                                    "Good Heat Transfer"

                                                    :

                                                    heatTransferEfficiency >= 70

                                                        ?

                                                        "Acceptable Performance"

                                                        :

                                                        "Poor Heat Transfer"

                                        }


                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Thermal Driving Force
                                    </td>


                                    <td>

                                        {

                                            deltaT >= 25

                                                ?

                                                "Adequate"

                                                :

                                                deltaT >= 15

                                                    ?

                                                    "Moderate"

                                                    :

                                                    "Low Driving Force"

                                        }


                                    </td>


                                </tr>



                                <tr>

                                    <td>
                                        Overall Reboiler Status
                                    </td>


                                    <td>

                                        {

                                            heatTransferEfficiency >= 85

                                                ?

                                                "Operating Normally"

                                                :

                                                "Requires Investigation"

                                        }


                                    </td>


                                </tr>



                            </tbody>


                        </table>



                    </div>

                )}


                {currentPage === 6 && (

                    /* ==========================================
                       PAGE 6
                       DIESEL PRODUCT QUALITY ANALYSIS
                    ========================================== */

                    <div className="receipt-page">


                        <h2 className="receipt-section-title">

                            6. DIESEL PRODUCT QUALITY ANALYSIS

                        </h2>



                        <h3>

                            Diesel Product Operating Data

                        </h3>



                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        Diesel Product Flow
                                    </td>

                                    <td>

                                        {dieselBottomFlow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Diesel Product Temperature
                                    </td>

                                    <td>

                                        {dieselBottomTemperature?.toFixed(2)} °C

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Diesel Product Pressure
                                    </td>

                                    <td>

                                        {dieselBottomPressure?.toFixed(3)} barg

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Diesel Recovery
                                    </td>

                                    <td>

                                        {dieselRecovery?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Diesel Stripping Loss
                                    </td>

                                    <td>

                                        {dieselLoss?.toFixed(4)} m³/hr

                                    </td>

                                </tr>


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Diesel Bottom Product Composition

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>


                                    <th>
                                        Composition
                                    </th>


                                </tr>


                            </thead>



                            <tbody>


                                <tr>

                                    <td>
                                        Diesel Hydrocarbon
                                    </td>

                                    <td>

                                        {

                                            (

                                                dieselComposition.Diesel *

                                                100

                                            )

                                                .toFixed(3)

                                        } %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Heavy Hydrocarbons
                                    </td>

                                    <td>

                                        {

                                            (

                                                dieselComposition.HeavyHydrocarbon *

                                                100

                                            )

                                                .toFixed(3)

                                        } %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Light Hydrocarbon
                                    </td>

                                    <td>

                                        {

                                            (

                                                dieselComposition.LightHydrocarbon *

                                                100

                                            )

                                                .toFixed(3)

                                        } %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Water
                                    </td>

                                    <td>

                                        {

                                            (

                                                dieselComposition.Water *

                                                100

                                            )

                                                .toFixed(3)

                                        } %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Total Composition
                                    </td>

                                    <td>

                                        100 %

                                    </td>

                                </tr>



                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Diesel Overhead Loss Composition

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>


                                    <th>
                                        Fraction
                                    </th>


                                </tr>


                            </thead>



                            <tbody>



                                <tr>

                                    <td>
                                        Diesel Vapour Loss
                                    </td>


                                    <td>

                                        {

                                            dieselGasComposition.Diesel

                                                ?

                                                (

                                                    dieselGasComposition.Diesel *

                                                    100

                                                )

                                                    .toFixed(3)

                                                :

                                                "0.000"

                                        } %

                                    </td>


                                </tr>



                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Diesel Product Assessment

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Recovery Performance
                                    </td>


                                    <td>

                                        {

                                            dieselRecovery >= 95

                                                ?

                                                "Excellent Recovery"

                                                :

                                                dieselRecovery >= 85

                                                    ?

                                                    "Good Recovery"

                                                    :

                                                    "Low Recovery"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Product Quality Status
                                    </td>


                                    <td>

                                        {

                                            dieselLoss <= 0.05

                                                ?

                                                "Low Hydrocarbon Loss"

                                                :

                                                "High Hydrocarbon Loss"

                                        }


                                    </td>


                                </tr>



                            </tbody>


                        </table>



                    </div>

                )}



                {currentPage === 7 && (

                    /* ==========================================
                       PAGE 7
                       KEROSENE PRODUCT QUALITY ANALYSIS
                    ========================================== */

                    <div className="receipt-page">


                        <h2 className="receipt-section-title">

                            7. KEROSENE PRODUCT QUALITY ANALYSIS

                        </h2>



                        <h3>

                            Kerosene Product Operating Data

                        </h3>



                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        Kerosene Product Flow
                                    </td>

                                    <td>

                                        {keroseneBottomFlow?.toFixed(3)} m³/hr

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Kerosene Product Temperature
                                    </td>

                                    <td>

                                        {keroseneBottomTemperature?.toFixed(2)} °C

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Kerosene Product Pressure
                                    </td>

                                    <td>

                                        {keroseneBottomPressure?.toFixed(3)} barg

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Kerosene Recovery
                                    </td>

                                    <td>

                                        {keroseneRecovery?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Kerosene Stripping Loss
                                    </td>

                                    <td>

                                        {keroseneLoss?.toFixed(4)} m³/hr

                                    </td>

                                </tr>


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Kerosene Bottom Product Composition

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>


                                    <th>
                                        Composition
                                    </th>


                                </tr>


                            </thead>



                            <tbody>


                                {

                                    Object.entries(

                                        keroseneComposition || {}

                                    )

                                        .map(

                                            ([component, value]) => (


                                                <tr key={component}>


                                                    <td>

                                                        {component}

                                                    </td>



                                                    <td>

                                                        {

                                                            Number(value * 100)

                                                                .toFixed(3)

                                                        } %

                                                    </td>


                                                </tr>


                                            )

                                        )

                                }


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Kerosene Overhead Loss Composition

                        </h3>



                        <table className="receipt-table">


                            <thead>

                                <tr>

                                    <th>
                                        Component
                                    </th>


                                    <th>
                                        Fraction
                                    </th>


                                </tr>


                            </thead>



                            <tbody>


                                {

                                    Object.entries(

                                        keroseneGasComposition || {}

                                    )

                                        .map(

                                            ([component, value]) => (


                                                <tr key={component}>


                                                    <td>

                                                        {component}

                                                    </td>



                                                    <td>

                                                        {

                                                            Number(value * 100)

                                                                .toFixed(3)

                                                        } %

                                                    </td>


                                                </tr>


                                            )

                                        )

                                }


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Kerosene Product Assessment

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Recovery Performance
                                    </td>


                                    <td>

                                        {

                                            keroseneRecovery >= 98

                                                ?

                                                "Excellent Recovery"

                                                :

                                                keroseneRecovery >= 95

                                                    ?

                                                    "Good Recovery"

                                                    :

                                                    keroseneRecovery >= 90

                                                        ?

                                                        "Acceptable Recovery"

                                                        :

                                                        "Requires Optimization"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Hydrocarbon Loss Performance
                                    </td>


                                    <td>

                                        {

                                            keroseneLoss <= 0.05

                                                ?

                                                "Very Low Loss"

                                                :

                                                keroseneLoss <= 0.15

                                                    ?

                                                    "Acceptable Loss"

                                                    :

                                                    "High Loss"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Product Quality Status
                                    </td>


                                    <td>

                                        {

                                            keroseneRecovery >= 97

                                                ?

                                                "On Specification"

                                                :

                                                "Review Operating Conditions"

                                        }


                                    </td>


                                </tr>



                            </tbody>


                        </table>




                    </div>

                )}



                {currentPage === 8 && (

                    /* ==========================================
                       PAGE 8
                       STRIPPER PERFORMANCE KPI SUMMARY
                    ========================================== */

                    <div className="receipt-page">


                        <h2 className="receipt-section-title">

                            8. STRIPPER PERFORMANCE KPI SUMMARY

                        </h2>



                        <h3>

                            Overall Operating Performance

                        </h3>



                        <table className="receipt-table">

                            <tbody>


                                <tr>

                                    <td>
                                        Overall Recovery
                                    </td>

                                    <td>

                                        {overallRecovery?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Overall Performance Index
                                    </td>

                                    <td>

                                        {overallPerformance?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Energy Efficiency
                                    </td>

                                    <td>

                                        {energyEfficiency?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Heat Transfer Efficiency
                                    </td>

                                    <td>

                                        {heatTransferEfficiency?.toFixed(2)} %

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Steam Consumption
                                    </td>

                                    <td>

                                        {steamConsumption?.toFixed(3)} m³/hr

                                    </td>

                                </tr>


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Stripping Operating Severity

                        </h3>



                        <table className="receipt-table">


                            <tbody>


                                <tr>

                                    <td>
                                        Steam to Hydrocarbon Ratio
                                    </td>

                                    <td>

                                        {steamRatio?.toFixed(4)}

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Steam Stripping Factor
                                    </td>

                                    <td>

                                        {steamStrippingFactor?.toFixed(4)}

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Temperature Factor
                                    </td>

                                    <td>

                                        {temperatureFactor?.toFixed(4)}

                                    </td>

                                </tr>



                                <tr>

                                    <td>
                                        Pressure Factor
                                    </td>

                                    <td>

                                        {pressureFactor?.toFixed(4)}

                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Stripping Severity
                                    </td>

                                    <td>

                                        {strippingSeverity?.toFixed(4)}

                                    </td>

                                </tr>


                            </tbody>


                        </table>




                        <br />



                        <h3>

                            Performance Interpretation

                        </h3>



                        <table className="receipt-table">


                            <tbody>



                                <tr>

                                    <td>
                                        Recovery Status
                                    </td>


                                    <td>

                                        {

                                            overallRecovery >= 97

                                                ?

                                                "Excellent Product Recovery"

                                                :

                                                overallRecovery >= 90

                                                    ?

                                                    "Acceptable Recovery"

                                                    :

                                                    "Poor Recovery"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Energy Utilization
                                    </td>


                                    <td>

                                        {

                                            energyEfficiency >= 90

                                                ?

                                                "Highly Efficient"

                                                :

                                                energyEfficiency >= 75

                                                    ?

                                                    "Acceptable Efficiency"

                                                    :

                                                    "Low Efficiency"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Stripping Operation
                                    </td>


                                    <td>

                                        {

                                            strippingSeverity >= 0.8

                                                ?

                                                "High Stripping Effectiveness"

                                                :

                                                strippingSeverity >= 0.5

                                                    ?

                                                    "Moderate Stripping Effectiveness"

                                                    :

                                                    "Low Stripping Effectiveness"

                                        }


                                    </td>


                                </tr>




                                <tr>

                                    <td>
                                        Overall Unit Condition
                                    </td>


                                    <td>

                                        {

                                            overallPerformance >= 90

                                                ?

                                                "Excellent Operation"

                                                :

                                                overallPerformance >= 75

                                                    ?

                                                    "Stable Operation"

                                                    :

                                                    "Optimization Required"

                                        }


                                    </td>


                                </tr>



                            </tbody>


                        </table>



                    </div>

                )}





                <hr />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25
                    }}
                >

                    <button
                        className="receipt-button"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        ◀ Previous
                    </button>

                    <strong>
                        Page {currentPage + 1} of 9
                    </strong>

                    <button
                        className="receipt-button"
                        disabled={currentPage === 8}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        Next ▶
                    </button>

                </div>

                <br />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 20
                    }}
                >

                    <button
                        className="receipt-button"
                        onClick={() => window.print()}
                    >
                        Print
                    </button>

                    <button
                        className="receipt-button"
                    >
                        Export PDF
                    </button>

                    <button
                        className="receipt-button"
                        onClick={onClose}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>


    )

};

export default StripperLaboratory;